import { Loader, Typography } from "@commonlibs";
import { BalanceProps } from "./Balance.types";
import { BALANCE_THRESHOLDS } from "./constants/balanceThresholds";
import { useFormatBalance } from "./hook/useFormatBalance";

//TODO: Import component from @commonlibs
const Balance = ({
    balance,
    options,
    units,
    unitsPosition = "right",
    action,
    isLoading = false,
    minimumFallbackDisplay,
    thresholds = BALANCE_THRESHOLDS,
    ...typographyProps
}: BalanceProps): JSX.Element => {
    const formattedBalance = useFormatBalance(balance, {
        numberFormatOptions: options,
        units,
        unitsPosition,
        action,
        thresholds,
        minimumFallbackDisplay,
    });

    return (
        <Typography numberOfLines={1} {...typographyProps}>
            {isLoading ? <Loader /> : formattedBalance}
        </Typography>
    );
};

export default Balance;
